<template>
    <v-container :class="{'pa-0' : $vuetify.breakpoint.xsOnly}" style="min-height:65vh;" id="body-wrapper">
        <v-flex xs12 style="min-height:65vh;" class="d-flex align-center">
            <v-progress-circular
                indeterminate
                :size="70"
                :width="7"
                :aria-label="$t('accessibility.loadingGeneric')"
                color="primary"
            />
        </v-flex>
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
    name: 'confirm-appt',
    data() {
        return {
            token: null,
            appointmentNumber: null,
            establishmentId: null,
        };
    },
    async mounted() {
        // If the route has a query param token & appointmentNumber
        if (this.$route.query.token && this.$route.query.appointmentNumber) {
            this.token = this.$route.query.token;
            this.appointmentNumber = this.$route.query.appointmentNumber;
            this.establishmentId = this.getEstablishment.id;
            await this.confirmAppointmentAPI();
        }
        else {
            const error = new Error(`Confirmation failed with token: ${this.$route.query.token} for apptNumber: ${this.$route.query.appointmentNumber}`);
            error.name = 'public-page/confirmation/missing-token-or-appt-number';

            this.$store.commit(
                'UPDATE_LAST_ERROR',
                error
            );

            await this.$router.push({ name: 'error' });
        }
    },
    computed: {
        ...mapGetters({
            captchaKey: 'captchaKey',
            locale: 'locale',
            getEstablishment: 'establishment/getEstablishment',
        }),
    },
    methods: {
        ...mapActions({
            confirmAppointment: 'other/confirmAppointment',
        }),
        async confirmAppointmentAPI() {
            try {
                await this.confirmAppointment({
                    token: this.token,
                    appointmentNumber: this.appointmentNumber,
                    establishmentId: this.establishmentId,
                });
                this.$store.commit('snackbar/SET_SNACK', {
                    message: this.$i18n.t('confirm.confirmSuccess'),
                    color: 'success',
                    timeout: -1,
                });
                this.token = null;
                this.appointmentNumber = null;
                await this.$router.push({ name: 'take-appt' });
            }
            catch (error) {
                await this.$router.push({ name: 'take-appt' });
                throw error;
            }
        },
    },
};
</script>
